import { formatDateMain } from '@hero/core';
import type { TFunction } from 'i18next';
import type { OfferMock } from '../mocks';

export function formatOfferTerm(t: TFunction, offer: OfferMock): string | null {
  if (!offer.terms) return null;
  const { value, unit } = offer.terms.term;
  const key =
    unit === 'days' ? `${value}_days` : unit === 'months' ? '6_months' : '1_year';
  return t(`term.${key}`);
}

export function formatOfferRepaymentDate(dateIso: string | undefined): string {
  if (!dateIso) return '—';
  return formatDateMain({
    date: new Date(dateIso),
    format: 'date_day',
  });
}

/** Schema stores fee % as a fraction (`0.05` = 5%). */
export function formatOfferFeePercentage(fraction: number): string {
  return `${(fraction * 100).toFixed(1)}%`;
}
